module.exports = __webpack_public_path__ + "static/hands-4277d16fd768049326f7afba569ef329.png";